import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-capitalize-text',
    templateUrl: './capitalize-text.component.html',
    styleUrls: ['./capitalize-text.component.scss']
})
export class CapitalizeTextComponent {
    @Input() public title: string;
}
